<template>
  <div>
    <b-card class="standardpage">
      <b-card-header>
        <b-row>
          <b-col cols="12" sm="6" class="text-right text-sm-left pt-1">
            <i :class="nlcodes.icon" class="mr-1"></i>
            <span>{{ nlcodes.title }}</span>
          </b-col>

        </b-row>
      </b-card-header>

      <div v-if="!component" class="availtable datatable">
        <b-card class="w-100pct mb-2">
          <b-card-body class="py-0">

            <b-row v-if="!showfilter">
              <b-col cols="12" sm="6" md="4" xl="3">
                <b-form-group label-cols="12" label="Description" label-size="sm">
                  <b-input-group>
                    <b-form-input v-model="name" :debounce="nlcodes.debounce" placeholder="Description"></b-form-input>
                    <b-input-group-append>
                      <b-button size="sm" variant="outline-secondary" :disabled="!name" @click="name = ''">
                        <i class="fa fa-remove"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
        <div class="px-3">
          <d-table classdivtable="availtable datatable" refid="nlcodes" :icon="nlcodes.icon" :busy="nlcodes.busy"
            :toolbarlibrary="nlcodes.toolbarlibrary" :tools="nlcodes.tools" :badges="nlcodes.badges"
            :fields="nlcodes.fields" :items="nlcodes.items" :limit="nlcodes.limit" :page="nlcodes.page"
            @load="nlcodes_load" @click="nlcodes_click" @changed="nlcodes_click('save', $event)" @select="nlcodes_select">
          </d-table>
        </div>
      </div>

      <div v-if="component">
        <component :is="component" :selection="nlcodes.selected" :config="cconfig" @discard="nlcodes_click('discard')"
          @go="nlcodes_click('go')"></component>
      </div>
      <!-- <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-right">
            <b-button squared size="sm" variant="secondary" @click="$emit('discard')">
              <i class="fa fa-chevron-left pr-1"></i>Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer> -->
    </b-card>
  </div>
</template>


<script>
import gql from "graphql-tag";

import NLCodeEdit from "./Components/NLCodeEdit";

export default {
  name: "NLCode",
  components: { NLCodeEdit },
  watch: {
    async name() {
      await this.nlcodes__load(0);
    },
  },
  data() {
    return {
      name: null,

      nlcodes: {
        title: "Chart Of Accounts",
        icon: "fa fa-list",
        debounce: 500,
        busy: false,
        page: 1,
        offset: 0,
        limit: 15,
        tools: "go,filter,export,clipboard,add,edit,deleteconfirm",
        toolbarlibrary: [],
        fields: [
          {
            key: "selected",
            label: "...",
            class: "text-center w-25px",
          },
          {
            key: "icon",
            label: "",
            class: "text-center w-35px",
          },
          {
            key: "id",
            label: "Code",
            sortable: true,
          },
          {
            key: "name",
            label: "Description",
            sortable: true,
          },

          {
            key: "actions",
            label: "Actions",
            class: "actions w-100px",
          },
        ],
        badges: [],
        items: [],
        selected: [],
        denied: [],
      },
    };
  },
  async mounted() {
    await this.nlcodes_load();
  },

  methods: {
    async nlcodes_load(offset, limit, page) {
      let state = this.nlcodes;

      if (offset || offset == 0) {
        state.offset = offset
      }
      if (limit || limit == 0) {
        state.limit = limit
      }
      if (page) {
        state.page = page
      }

      state.busy = true;

      let variables = {
        offset: state.offset,
        limit: state.limit,

        name: this.name,
        dateformat: "DD/MM/YYYY",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query nlcodes(
              $limit: Int
              $offset: Int
              $name: String            
              $dateformat: String
            ) {
              nlcodes(
                limit: $limit
                offset: $offset
                name: $name               
                dateformat: $dateformat
              ) {
                id
               name
                rows
              }
            }
          `,
          variables,
        });

        // USE LOCAL VARIABLE
        if (limit == 0) {
          state.selected = response.data.nlcodes
        } else {
          state.items = []
          state.items = response.data.nlcodes;
        }


      } catch (error) {
        console.log(error);
      }

      state.busy = false;
    },
    async nlcodes_click(a, ss) {

      switch (a) {
        case "filter":
          this.showfilter = !this.showfilter;
          break;
          case "discard":
          this.component = null;
          break;

        case "go":
          this.component = null;
          this.nlcodes_load();
          break;
        case "add":
        case "edit":
          this.component = "NLCodeEdit";
          break;

        case "save":
          this.saveit(ss);
          break;

        case "delete":
          this.deleteit(ss);
          break;
      }
    },
    async nlcodes_select(ss, tools) {

      let state = this.nlcodes;

      state.selected = ss;
      let tool = null;

      if (tools) {
        let enabled = ["back", "save", "go", "filter", "add", "export","clipboard"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = false;
          }
        });
        // == 1
        enabled = ["edit"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length == 1 ? false : true;
          }
        });
        // > 1
        enabled = ["deleteconfirm"];
        enabled.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.disabled = ss.length > 0 ? false : true;
          }
        });

        if (!state.denied) {
          state.denied = [];
        }
        state.denied.forEach(function (action, index) {
          tool = tools.find((o) => o.action == action);
          if (tool) {
            tool.visible = false;
          }
        });
      }
    },

    async saveit(ss) {

      this.busy = true;

      let variables = { rows: this.cleanit(ss) };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation nlcodes_save(
                $rows: [NLCode_input]             
              ) {
                nlcodes_save(rows: $rows) {
                    id
                    name                
                }
              }
            `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
    async deleteit(ss) {

      let rows = [];
      ss.forEach(function (v) {
        rows.push({ id: v.id });
      });

      let variables = {
        rows,
      };

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
              mutation nlcodes_delete(
                $rows: [NLCode_input]
              ) {
                nlcodes_delete(rows: $rows) {
                  id
                }
              }
            `,
          variables,
        });
      } catch (error) {
        console.log(error);
      }

      await this.nlcodes__load(0);
    },
  },
};
</script>

<style></style>